/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { Mentions } from 'antd';
import { useSpring, animated } from 'react-spring';

import NewReplyBoxWrap from './NewReplyBoxWrap';
import FeedPostCommentReplies from './FeedPostCommentReplies';
import GiphyEmojiButtons from './GiphyEmojiButtons';
import FeedDropdownOptions from './FeedDropdownOptions';
import SendButton from './SendButton';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import TBButton from '../../../../shared/components/Button/Button';
import {
  transformPostText,
  imageFlipper,
  urlSnapper,
  pictureSelector,
  userParser,
  buildSubmissionObject,
  findFeedIndex,
  findCommentIndex,
  dateCreator,
  editMentionText,
  extractMentionsFromText,
  replaceMentionsInMessage,
  filterUserMentions,
} from '../../helperFunctions';

import useFeed from '../hooks/useFeed';
import {
  openMessageVideo,
  openImageLightbox,
  setIsReplyActivatedRedux,
  setScrollTrueFalse,
  setUploadMediaFalse,
  setUploadMedia,
  setIsCommentClickedRedux,
  setActiveReduxModal,
  setReportPostInfo,
  setActiveMediaBarOb,
} from '../../ducks/feedActions';
import { feedTracker } from '../../../../shared/utils/amplitudeHelper';

const CommentActionsContainer = styled('div')`
  font-family: 'Nunito Sans', sans-serif;
  display: flex;
  color: #777;
  font-weight: 400;
  font-size: 10px;
  line-height: 125%;
  user-select: none;
  padding-top: 5px;
  align-items: center;
  gap: 8px;
`;

const DropdownDiv = styled('div')`
  position: absolute;
  margin-left: 450px;
`;

const FeedPostCommentContent = styled('div')`
  padding: 8px 0 0px;
  font-size: 12px;
  .reply-author {
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    font-size: 12px;
  }
  .reply-body {
    font-family: 'Nunito Sans', sans-serif;
    padding: 10px 0;
    font-size: 13px;
    .smaller-input {
      width: 100%;
      .MuiOutlinedInput-multiline {
        padding: 7px;
      }
      .MuiInputBase-multiline.MuiInputBase-marginDense {
        padding: 7px;
      }
      .MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense {
        padding: 7px;
      }
      .MuiOutlinedInput-inputMarginDense {
        padding-left: 5px !important;
        margin-top: 2px !important;
      }
    }
  }
`;

const FeedPostCommentDiv = styled('div')`
  font-size: 12px;
  margin-bottom: 10px;
`;

const FistBumpContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: ${(props) => (props.isTvMode ? '' : 'pointer')};
  color: ${(props) => (props.isBumped ? '#ff6600' : '')};
  :hover {
    color: ${(props) => (props.isBumped || props.isTvMode ? '' : '#444444')};
  }
`;

const FormWrapper = styled('div')`
  width: 98%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MediaBox = styled('div')`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  padding-left: 0;
  max-height: 300px;
  width: 100%;
  position: relative;
  .media-image {
    max-height: 300px;
    width: 100%;
    object-fit: cover;
  }
`;

const VideoIcon = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100px;
  border-radius: 50%;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
`;

const MediaBoxEdit = styled('div')`
  margin-right: ${(props) => (props.activeMediaBarOb[props.comment.id] && props.uploadMedia
    ? '15px'
    : '0px')};
  .media-box-div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: 0;
    margin-left: 0px;
    left: 0px;
    min-height: 30px;
    min-width: 30px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-image: ${(props) => `url(${props.image})`};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border: 0px solid #ced4da;
    border-radius: 50%;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .remove-media {
    display: ${(props) => (props.uploadMedia ? 'flex' : 'none')};
    border-radius: 50%;
    height: 16px;
    width: 16px;
    position: absolute;
    left: 25px;
    z-index: 100;
    top: -5px;
    background: #d6d6d6;
  }
`;

const PostTextContainer = styled('div')`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  .text-area {
    width: 100%;
    white-space: pre-line;
    padding-right: 100px;
    border-radius: 10px;
    padding: 4px 0px;
  }
`;

const ReplyButtonText = styled('div')`
  display: flex;
  justify-content: center;
  :hover {
    color: ${(props) => (!props.disabled ? '#444444' : '')};
  }
  cursor: ${(props) => (!props.disabled ? 'pointer' : '')};
`;

const TextActionsContainer = styled('div')`
  display: flex;
  align-items: center;
  position: absolute;
  right: 10px;
  .send-button {
    margin: 0px;
  }
`;

const UserPicDiv = styled('div')`
  position: absolute;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-image: ${(feedObject) => `url(${pictureSelector(feedObject.props.userPic, 70, 60)})`};
  background-size: contain;
  min-width: 35px;
  margin-left: -50px;
  margin-top: 5px;
`;

const FeedPostComment = ({ comment, feedObject }) => {
  const {
    handleEditFeedPostComment,
    handleDeleteFeedPostComment,
    handleFistBumpComment,
  } = useFeed();
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const feed = useSelector((state) => state.feed.data.feed);
  const pinnedFeed = useSelector((state) => state.feed.data.pinnedFeed);
  const uploadMedia = useSelector((state) => state.feed.data.uploadMedia);
  const scrollTrueId = useSelector((state) => state.feed.data.scrollTrueId);
  const users = useSelector((state) => state.feed.data.users);
  const activeMediaBarOb = useSelector(
    (state) => state.feed.data.activeMediaBarOb,
  );
  const isTvMode = useSelector((state) => state.feed.data.isTvMode);

  const [userMentions, setUserMentions] = useState([]);
  const [bumpCounter, setBumpCounter] = useState(comment.fistBumps);
  const [isBumped, setIsBumped] = useState(comment.fistBumpActive);
  const [commentText, setCommentText] = useState(comment.postText);
  const [isEditing, setIsEditing] = useState(false);
  const [showReplies, setShowReplies] = useState(false);
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);

  useEffect(() => {
    if (isEditing) {
      const mentions = extractMentionsFromText(comment.postText);
      setUserMentions(mentions);
    } else {
      setUserMentions([]);
    }
  }, [isEditing, comment.postText]);

  const mediaBoxStyle = useSpring({
    opacity: uploadMedia ? '1' : '0',
    minWidth: uploadMedia ? '30px' : '0px',
    maxWidth: uploadMedia ? '30px' : '0px',
  });

  const editFormRef = useRef();

  const feedPostCommentRef = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    if (isEditing && comment?.media && Object.keys(comment.media).length) {
      batch(() => {
        dispatch(setUploadMedia(comment.media));
        dispatch(setActiveMediaBarOb({ [comment.id]: true }));
      });
    }
  }, [isEditing, comment?.media, dispatch]);

  const handleSetEdit = () => {
    feedTracker('Normal Mode', `Edit comment ${isEditing ? 'canceled' : 'activated'}`);
    setIsEditing((prevEditingState) => !prevEditingState);
  };

  const dropdownEditText = !isEditing ? 'Edit' : 'Cancel Edit';

  const handleDeleteComment = () => {
    const feedObjectIndex = findFeedIndex(feedObject, feed, pinnedFeed);
    const commentObjectIndex = findCommentIndex(comment, feedObject);
    const { pinned } = feedObject;

    handleDeleteFeedPostComment({
      accountCode: currentUser.accountCode,
      feedIndex: feedObjectIndex,
      feedId: feedObject.id,
      pinned,
      commentIndex: commentObjectIndex,
      commentId: comment.id,
    });
    feedTracker('Normal Mode', 'Comment deleted');
  };

  const handleReportComment = () => {
    dispatch(setActiveReduxModal('report-post-modal'));
    dispatch(setReportPostInfo('Comment', feedObject.id, comment.id));
    feedTracker('Normal Mode', 'Report modal opened - comment');
  };

  const dropdownOptions = () => (
    <FeedDropdownOptions
      contentObject={comment}
      editFunction={handleSetEdit}
      editText={dropdownEditText}
      deleteFunction={handleDeleteComment}
      reportFunction={handleReportComment}
    />
  );

  useEffect(() => {
    if (feedPostCommentRef.current) {
      if (scrollTrueId === comment.id) {
        feedPostCommentRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
        setScrollTrueFalse();
      }
    }
  }, [scrollTrueId]);

  useEffect(() => {
    if (editFormRef.current) {
      if (isEditing) {
        editFormRef.current.focus();
      }
    }
  }, [isEditing]);

  const fistBumpCommentOnSuccess = (updatedBumpState, updatedBumpCounter) => {
    setIsBumped(updatedBumpState);
    setBumpCounter(updatedBumpCounter);
  };

  const handleClickFistBump = () => {
    if (isTvMode) {
      return;
    }

    const feedObjectIndex = findFeedIndex(feedObject, feed, pinnedFeed);
    const commentObjectIndex = findCommentIndex(comment, feedObject);
    const { pinned } = feedObject;

    handleFistBumpComment({
      accountCode: currentUser.accountCode,
      bool: !comment.fistBumpActive,
      feedPostId: feedObject.id,
      commentId: comment.id,
      feedObjectIndex,
      commentObjectIndex,
      pinned,
      onSuccess: fistBumpCommentOnSuccess,
    });
    feedTracker('Normal Mode', `Fist bump comment ${!comment.fistBumpActive ? 'activated' : 'deactivated'}`);
  };

  const handleShowReplyClick = () => {
    if (comment?.replies?.length) {
      feedTracker('Normal Mode', `${showReplies ? 'Hide' : 'See'} comment replies clicked`);
      setShowReplies((prevShowRepliesState) => !prevShowRepliesState);
    }
  };

  const handleFormBlur = () => {
    dispatch(setIsCommentClickedRedux({}));
  };

  const handleRemoveMedia = () => {
    dispatch(setUploadMediaFalse());
  };

  const handleMentionsFocus = () => {
    dispatch(setIsReplyActivatedRedux({}));
  };

  const handleMentionsSelect = (selection) => {
    if (selection && selection.value) {
      // Find the user that matches the selected value
      const selectedUser = users.find((user) => `${user.first} ${user.last}` === selection.value);

      if (selectedUser) {
        const submissionValue = `[u=${selectedUser.id}|${selectedUser.first} ${selectedUser.last}]`;
        setUserMentions((prevUserMentions) => [
          ...prevUserMentions,
          submissionValue,
        ]);
      }
    }
  };

  const handleMentionsChange = (string) => {
    setCommentText(string);
    filterUserMentions(userMentions, setUserMentions, string);
  };

  const handleReplyClick = () => {
    if (feedObject.replyAllowed && !isEditing) {
      const newOb = {};
      newOb[comment.id] = true;
      dispatch(setIsReplyActivatedRedux(newOb));
      feedTracker('Normal Mode', 'Reply to comment clicked');
    }
  };

  const submitDisabled = (messageBody) => (!uploadMedia.id && !messageBody?.trim().length)
    || isSubmittingEdit;

  const handleSubmit = () => {
    if (submitDisabled(commentText)) return;
    setIsSubmittingEdit(true);
    const processedText = commentText
      ? replaceMentionsInMessage(commentText, userMentions)
      : '';
    const submissionOb = buildSubmissionObject(processedText, uploadMedia);

    const feedObjectIndex = findFeedIndex(feedObject, feed, pinnedFeed);
    const commentObjectIndex = findCommentIndex(comment, feedObject);

    handleEditFeedPostComment({
      accountCode: currentUser.accountCode,
      submissionOb,
      feedObjectIndex,
      feedObjectId: feedObject.id,
      commentObjectIndex,
      commentObjectId: comment.id,
      isPinned: feedObject.pinned,
    });
    feedTracker('Normal Mode', 'Comment edited');
    batch(() => {
      dispatch(setUploadMediaFalse());
      dispatch(setActiveMediaBarOb({}));
    });
    setIsEditing(false);
    // Brief delay to show successful edit feedback to user
    setTimeout(() => {
      setIsSubmittingEdit(false);
    }, 300);
  };

  const handleMentionsKeyPress = (e) => {
    const { key, shiftKey } = e;
    if (key === 'Enter' && !shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSendClick = () => {
    handleSubmit();
  };

  const handleMediaClick = () => {
    if (
      comment.media.type === 'EXTERNAL_URL'
      || comment.media.type === 'IMAGE'
    ) {
      dispatch(openImageLightbox(comment.media.mediaUrl));
      feedTracker('Normal Mode', 'Comment media clicked');
    }
  };

  const handleVideoClick = () => {
    dispatch(openMessageVideo(comment.media.mediaUrl));
    // Comments don't currently support video upload
    // feedTracker('Normal Mode', 'Comment video clicked');
  };

  const renderMediaBoxEdit = () => comment
    && activeMediaBarOb[comment.id] && (
      <MediaBoxEdit
        activeMediaBarOb={activeMediaBarOb}
        comment={comment}
        uploadMedia={uploadMedia}
        image={urlSnapper(uploadMedia)}
      >
        <animated.div style={mediaBoxStyle} className='media-box-div'>
          <TBButton
            icon='remove'
            iconOnly
            square
            onClick={handleRemoveMedia}
            className='remove-media'
          />
        </animated.div>
      </MediaBoxEdit>
  );

  const renderMentionsInput = () => (
    <Mentions
      className='text-area'
      placement='bottom'
      value={editMentionText(commentText)}
      onFocus={handleMentionsFocus}
      onSelect={handleMentionsSelect}
      id={feedObject ? feedObject.id : ''}
      name='messageBody'
      onKeyDown={handleMentionsKeyPress}
      onChange={handleMentionsChange}
    >
      {users && !!users.length && userParser(users)}
    </Mentions>
  );

  const renderTextActions = () => (
    <TextActionsContainer>
      <GiphyEmojiButtons
        setText={setCommentText}
        text={commentText}
        commentId={comment.id}
        fieldName='messageBody'
      />
      <SendButton
        onClick={handleSendClick}
        disabled={submitDisabled(commentText)}
        className='send-button'
      />
    </TextActionsContainer>
  );

  const renderEditForm = () => (
    <FormWrapper onBlur={handleFormBlur}>
      {renderMediaBoxEdit()}
      <PostTextContainer>
        {renderMentionsInput()}
        {renderTextActions()}
      </PostTextContainer>
    </FormWrapper>
  );

  const renderMediaImage = () => comment?.media?.mediaUrl && (
    <img
      src={imageFlipper(comment.media)}
      alt='media'
      className='media-image'
    />
  );

  const renderVideoIcon = () => comment?.media?.type === 'VIDEO' && (
    <VideoIcon onClick={handleVideoClick}>
      <IcomoonReact iconSet={iconSet} size={50} icon='altrightarrow' />
    </VideoIcon>
  );

  const renderMediaSection = () => {
    if (isEditing || (isSubmittingEdit && !uploadMedia.id) || !comment.media) return null;

    return (
      <MediaBox onClick={handleMediaClick}>
        {renderMediaImage()}
        {renderVideoIcon()}
      </MediaBox>
    );
  };

  const renderFistBumpSection = () => (
    <FistBumpContainer
      isBumped={isBumped}
      isTvMode={isTvMode}
      onClick={handleClickFistBump}
    >
      <div>{bumpCounter === 1 ? 'Fist Bump' : 'Fist Bumps'}</div>
      <div>
        (
        {bumpCounter}
        )
      </div>
    </FistBumpContainer>
  );

  const renderReplyButtons = () => {
    if (isTvMode) return null;

    return (
      <>
        <div onClick={handleReplyClick}>
          <ReplyButtonText disabled={!feedObject.replyAllowed || isEditing}>
            {feedObject.replyAllowed ? 'Reply' : 'Replies Disabled'}
          </ReplyButtonText>
        </div>
        {!!comment?.replies?.length && (
          <ReplyButtonText
            onClick={handleShowReplyClick}
            disabled={!comment?.replies?.length}
          >
            {showReplies
              ? 'Hide Replies'
              : `See Replies (${comment?.replies?.length})`}
          </ReplyButtonText>
        )}
      </>
    );
  };

  const renderCommentActions = () => (
    <CommentActionsContainer>
      {renderFistBumpSection()}
      <div>{dateCreator(comment.createdAt)}</div>
      <div>&#9679;</div>
      {renderReplyButtons()}
    </CommentActionsContainer>
  );

  return (
    <FeedPostCommentDiv ref={feedPostCommentRef}>
      <UserPicDiv props={comment} />
      {!isTvMode && <DropdownDiv>{dropdownOptions()}</DropdownDiv>}
      <FeedPostCommentContent isTvMode={isTvMode} isBumped={isBumped}>
        <div className='reply-author'>{comment.userName}</div>
        <div className='reply-body'>
          {!isEditing
            ? comment.postText
              ? transformPostText(comment.postText, true)
              : ''
            : renderEditForm()}
        </div>
        {renderMediaSection()}
        {renderCommentActions()}
      </FeedPostCommentContent>
      {showReplies && !!comment?.replies?.length && (
        <FeedPostCommentReplies
          feedPost={feedObject}
          comment={comment}
          replies={comment.replies}
        />
      )}
      <NewReplyBoxWrap
        feedObject={feedObject}
        commentObject={comment}
        showReplies={showReplies}
        setShowReplies={setShowReplies}
      />
    </FeedPostCommentDiv>
  );
};

FeedPostComment.propTypes = {
  comment: PropTypes.instanceOf(Object).isRequired,
  feedObject: PropTypes.instanceOf(Object).isRequired,
};

export default FeedPostComment;
